export const componentsContext = require.context("/var/projects/chem_bio_security/lib/mz_ui/app/components", true, /_controller\.js$/),
             controllersContext = require.context("/var/projects/chem_bio_security/lib/mz_ui/app/javascript/controllers", true, /_controller\.js$/);

